import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Teodor Sandu
 * id 9768571C-CF87-4146-A9AF-A4E76BBD9248
 * name floor-lamp-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLampOutlineIcon = createSvgIcon(<><path d="M15 2L17 9H7L9 2M13.6 4H10.4L9.55 7H14.45M11 10H13V20H16V22H8V20H11Z" /></>, 'FloorLampOutlineIcon');
export default FloorLampOutlineIcon